import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-xl border px-3 py-1.5 text-xs font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-0 hover:scale-105",
  {
    variants: {
      variant: {
        default:
          "border-transparent gradient-primary text-primary-foreground hover:shadow-primary hover:scale-110",
        secondary:
          "border-transparent bg-secondary/90 text-secondary-foreground hover:bg-secondary hover:shadow-secondary",
        tertiary:
          "border-transparent bg-tertiary/90 text-tertiary-foreground hover:bg-tertiary hover:shadow-tertiary",
        destructive:
          "border-transparent bg-destructive/90 text-destructive-foreground hover:bg-destructive hover:scale-110",
        success:
          "border-transparent bg-success/90 text-success-foreground hover:bg-success hover:scale-110",
        outline: "text-foreground glass border-border/50 hover:glass-strong hover:border-primary/50",
        glow: "border-transparent gradient-primary text-primary-foreground shadow-primary animate-pulse-glow",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
